module.exports = __webpack_public_path__ + "static/media/icon-laundry.3a3afc58.svg";